(function () {
  // Announcement bar rotation
  var ann = document.querySelector('.announce span[data-rotate]');
  if (ann) {
    try {
      var items = JSON.parse(ann.getAttribute('data-rotate'));
      if (items.length > 1) {
        var i = 0;
        setInterval(function () {
          ann.style.opacity = 0;
          setTimeout(function () {
            i = (i + 1) % items.length;
            ann.textContent = items[i];
            ann.style.opacity = 1;
          }, 400);
        }, 3500);
      }
    } catch (e) {}
  }

  // Header shadow on scroll
  var header = document.querySelector('header.site');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll); onScroll();
  }

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    var setMenu = function (open) {
      mobileMenu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
      menuToggle.classList.toggle('open', open);
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    menuToggle.addEventListener('click', function () { setMenu(mobileMenu.hidden); });
    mobileMenu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }

  // Reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // Smooth-scroll category tiles / anchor buttons
  document.querySelectorAll('[data-scroll]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var id = el.getAttribute('data-scroll');
      var target = document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // ---- Product page: colour variant picker + qty + buy now ----
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var shopDomain = pdp.getAttribute('data-shop');
    var variantInput = pdp.querySelector('[data-variant-id]');
    var priceNowEls = pdp.querySelectorAll('[data-price-now]');
    var priceWas = pdp.querySelector('[data-price-was]');
    var colourNameEls = pdp.querySelectorAll('[data-colour-name]');
    var mainImg = pdp.querySelector('[data-main-image]');
    document.body.classList.add('has-sticky-buy');
    var qtyInput = pdp.querySelector('[data-qty]');
    var stockWrap = pdp.querySelector('[data-stock-wrap]');
    var stockText = pdp.querySelector('[data-stock-text]');

    pdp.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        pdp.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        if (variantInput) variantInput.value = sw.getAttribute('data-vid');
        colourNameEls.forEach(function (el) { el.textContent = sw.getAttribute('data-name'); });
        if (sw.getAttribute('data-price')) priceNowEls.forEach(function (el) { el.textContent = sw.getAttribute('data-price'); });
        if (priceWas && sw.getAttribute('data-compare')) priceWas.textContent = sw.getAttribute('data-compare');
        var img = sw.getAttribute('data-img');
        if (img && mainImg) mainImg.src = img;
        // live stock for the selected colour
        var managed = sw.getAttribute('data-managed');
        var st = sw.getAttribute('data-stock');
        if (stockText && managed === 'shopify' && st !== null && st !== '') {
          var n = parseInt(st, 10), low = false, msg;
          if (n <= 0) { msg = 'Sold out'; }
          else if (n <= 10) { msg = '🔥 Only ' + n + ' left — selling fast'; low = true; }
          else { msg = '✓ In stock — ships this week'; }
          stockText.textContent = msg;
          if (stockWrap) { stockWrap.classList.toggle('low', low); stockWrap.classList.toggle('ok', !low); }
        }
      });
    });

    pdp.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty-step'), 10);
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = v;
      });
    });

    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { if (mainImg) mainImg.src = t.getAttribute('data-thumb'); });
    });

    pdp.querySelectorAll('[data-buy]').forEach(function (buy) {
      buy.addEventListener('click', function () {
        var vid = variantInput ? variantInput.value : buy.getAttribute('data-vid');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (!vid) return;
        window.location.href = 'https://' + shopDomain + '/cart/' + vid + ':' + qty;
      });
    });
  }
})();
